package com.exura.features.plandefinition.usecase

import com.exura.features.plandefinition.domain.model.plan.BasePlan
import com.exura.features.plandefinition.domain.repository.ProviderPlanDefinitionRepository

class GetUnversionedPlanDefinitionUseCase(
    private val repository: ProviderPlanDefinitionRepository,
) {
    suspend operator fun invoke(id: String): Result<BasePlan>
    = repository.read(id)

}
